module.exports = __webpack_public_path__ + "img/empty-header.90e3ae39.png";